import React, { createContext, useContext, useState } from 'react';

const CountryContext = createContext(null);

const COUNTRY_CONFIG = {
  IN: { code: 'IN', flag: '\u{1F1EE}\u{1F1F3}', currency: 'INR', name: 'India', symbol: '\u20B9' },
};

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) throw new Error('useCountry must be used within CountryProvider');
  return context;
};

export const CountryProvider = ({ children }) => {
  const [country] = useState('IN');

  const setCountry = () => {
    // India-only instance - no country switching needed
  };

  const config = COUNTRY_CONFIG.IN;
  const currency = config.symbol;
  const flag = config.flag;

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return `${currency} 0`;
    const num = Number(value);
    if (isNaN(num)) return `${currency} 0`;
    if (num >= 10000000) return `${currency} ${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `${currency} ${(num / 100000).toFixed(2)} L`;
    if (num >= 1000) return `${currency} ${num.toLocaleString('en-IN')}`;
    return `${currency} ${num.toFixed(0)}`;
  };

  return (
    <CountryContext.Provider value={{ country, setCountry, config, currency, flag, formatCurrency, COUNTRY_CONFIG }}>
      {children}
    </CountryContext.Provider>
  );
};
